import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const SmsSurveyCreatePage = lazy(() => import('src/pages/sms-surveys/sms-survey-create'));
const SmsSurveyEditPage = lazy(() => import('src/pages/sms-surveys/sms-survey-edit'));

// ----------------------------------------------------------------------

export const smsSurveyRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'sms-surveys/create',
        element: <SmsSurveyCreatePage />,
      },
      {
        path: 'sms-surveys/:smsSurveyId/edit',
        element: <SmsSurveyEditPage />,
      },
    ],
  },
];
